<template>
  <Transition name="wave-transition">
    <div v-show="isPageLoading" class="wave-wrapper">
      <div class="wave-item-top">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 320"
          class="wave-svg-top"
          preserveAspectRatio="none"
        >
          <path
            fill="#743b26"
            fill-opacity="1"
            d="M0,256L60,266.7C120,277,240,299,360,261.3C480,224,600,128,720,112C840,96,960,160,1080,197.3C1200,235,1320,245,1380,250.7L1440,256L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
          />
        </svg>
      </div>
      <div class="wave-box" />
      <div class="wave-item-bottom">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 320"
          class="wave-svg-bottom"
          preserveAspectRatio="none"
        >
          <path
            fill="#743b26"
            fill-opacity="1"
            d="M0,160L60,138.7C120,117,240,75,360,96C480,117,600,203,720,245.3C840,288,960,288,1080,256C1200,224,1320,160,1380,128L1440,96L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
          />
        </svg>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const nuxtApp = useNuxtApp()
const isPageLoading = ref(false)

onMounted(() => {
  nuxtApp.hook('page:start', () => {
    document.body.classList.add('route-change')
    isPageLoading.value = true
  })

  nuxtApp.hook('page:finish', () => {
    document.body.classList.remove('route-change')
    isPageLoading.value = false
  })
})
</script>

<style lang="scss" scoped>
.wave-wrapper {
  position: fixed;
  z-index: 1000;
  width: 100vw;
  height: 200vh;
  transform: translateY(-50vh);
}

.wave-item-top,
.wave-item-bottom {
  display: flex;
  height: 50vh;
}

.wave-item-top {
  align-items: flex-end;
}

.wave-item-bottom {
  align-items: flex-start;
}

.wave-box {
  height: 100vh;
  background-color: #743b26;
}

.wave-svg-bottom {
  // Fix for an svg, because it was not sticking to the sibling element
  // and was creating 1/2px visual gap, caused by browser rendering
  top: -2px;
  transform: rotate(180deg);
}

.wave-svg-top {
  // Fix for an svg, because it was not sticking to the sibling element
  // and was creating 1/2px visual gap, caused by browser rendering
  bottom: -2px;
}

.wave-svg-top,
.wave-svg-bottom {
  position: relative;
  display: block;
  width: 100%;
  height: min(30vw, 50vh);
}

.wave-transition {
  &-enter-active {
    transition: transform 0.6s ease-out;
  }

  &-leave-active {
    transition: transform 0.6s cubic-bezier(1, 0.5, 0.8, 1);
  }

  &-enter-from {
    transform: translateY(-200vh);
  }

  &-leave-to {
    transform: translateY(100vh);
  }
}
</style>
